/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { DailyRateWithCurrency } from './';
import {
    DailyRateWithCurrencyFromJSON,
    DailyRateWithCurrencyFromJSONTyped,
    DailyRateWithCurrencyToJSON,
} from './';
import type { ExperienceLevel } from './';
import {
    ExperienceLevelFromJSON,
    ExperienceLevelFromJSONTyped,
    ExperienceLevelToJSON,
} from './';
import type { NameDisplayOption } from './';
import {
    NameDisplayOptionFromJSON,
    NameDisplayOptionFromJSONTyped,
    NameDisplayOptionToJSON,
} from './';
import type { PostalAddress } from './';
import {
    PostalAddressFromJSON,
    PostalAddressFromJSONTyped,
    PostalAddressToJSON,
} from './';
import type { Skill } from './';
import {
    SkillFromJSON,
    SkillFromJSONTyped,
    SkillToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateHeaderSectionRequest
 */
export interface UpdateHeaderSectionRequest {
    /**
     * 
     * @type {DailyRateWithCurrency}
     * @memberof UpdateHeaderSectionRequest
     */
    dailyRate: DailyRateWithCurrency;
    /**
     * 
     * @type {ExperienceLevel}
     * @memberof UpdateHeaderSectionRequest
     */
    experienceLevel: ExperienceLevel;
    /**
     * 
     * @type {string}
     * @memberof UpdateHeaderSectionRequest
     */
    headline: string;
    /**
     * 
     * @type {PostalAddress}
     * @memberof UpdateHeaderSectionRequest
     */
    location: PostalAddress;
    /**
     * 
     * @type {NameDisplayOption}
     * @memberof UpdateHeaderSectionRequest
     */
    nameDisplayOption: NameDisplayOption;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateHeaderSectionRequest
     */
    rqthDisplayEnabled: boolean;
    /**
     * 
     * @type {Array<Skill>}
     * @memberof UpdateHeaderSectionRequest
     */
    topSkills: Array<Skill>;
}

/**
 * Check if a given object implements the UpdateHeaderSectionRequest interface.
 */
export function instanceOfUpdateHeaderSectionRequest(value: object): value is UpdateHeaderSectionRequest {
    if (!('dailyRate' in value) || value['dailyRate'] === undefined) return false;
    if (!('experienceLevel' in value) || value['experienceLevel'] === undefined) return false;
    if (!('headline' in value) || value['headline'] === undefined) return false;
    if (!('location' in value) || value['location'] === undefined) return false;
    if (!('nameDisplayOption' in value) || value['nameDisplayOption'] === undefined) return false;
    if (!('rqthDisplayEnabled' in value) || value['rqthDisplayEnabled'] === undefined) return false;
    if (!('topSkills' in value) || value['topSkills'] === undefined) return false;
    return true;
}

export function UpdateHeaderSectionRequestFromJSON(json: any): UpdateHeaderSectionRequest {
    return UpdateHeaderSectionRequestFromJSONTyped(json, false);
}

export function UpdateHeaderSectionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateHeaderSectionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'dailyRate': DailyRateWithCurrencyFromJSON(json['dailyRate']),
        'experienceLevel': ExperienceLevelFromJSON(json['experienceLevel']),
        'headline': json['headline'],
        'location': PostalAddressFromJSON(json['location']),
        'nameDisplayOption': NameDisplayOptionFromJSON(json['nameDisplayOption']),
        'rqthDisplayEnabled': json['rqthDisplayEnabled'],
        'topSkills': ((json['topSkills'] as Array<any>).map(SkillFromJSON)),
    };
}

export function UpdateHeaderSectionRequestToJSON(value?: UpdateHeaderSectionRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'dailyRate': DailyRateWithCurrencyToJSON(value['dailyRate']),
        'experienceLevel': ExperienceLevelToJSON(value['experienceLevel']),
        'headline': value['headline'],
        'location': PostalAddressToJSON(value['location']),
        'nameDisplayOption': NameDisplayOptionToJSON(value['nameDisplayOption']),
        'rqthDisplayEnabled': value['rqthDisplayEnabled'],
        'topSkills': ((value['topSkills'] as Array<any>).map((v) => SkillToJSON(v))),
    };
}

